import type { SeriesPlaylist, TvShowEpisode } from '@setplex/tria-api'
import type { TvShowEpisodePayment } from '../interfaces'

import {
  getEpisodePaymentExternalId,
  getPaymentTvShowEpisodeMediaType,
} from '../lib'

export const formatTvShowEpisodePayment = (
  episode: TvShowEpisode,
  query: URLSearchParams,
  seriesPlaylist: SeriesPlaylist | null
): TvShowEpisodePayment => {
  const {
    id,
    name,
    free,
    purchaseInfo,
    displayNumber,
    landscapeImageUrl,
    length,
    episodePriceSettings,
    seasonPriceSettings,
    tvShowPriceSettings,
  } = episode

  const tvShowId = query.get('tvshowId')
  const seasonId = query.get('seasonId')
  const queryCategoryId = query.get('categoryId') ?? ''
  const queryCollectionId = query.get('collectionId') ?? ''
  const queryShowIndex = query.get('showIndex') ?? ''

  return {
    free: Boolean(free),
    name: name ?? '',
    displayNumber: displayNumber ?? '',
    landscapeImageUrl: landscapeImageUrl ?? '',
    length: length ?? '',
    episodePriceSettings: episodePriceSettings ?? null,
    seasonPriceSettings: seasonPriceSettings ?? null,
    tvShowPriceSettings: tvShowPriceSettings ?? null,
    purchaseInfo: purchaseInfo ?? null,
    id: Number(id),
    tvShowId: Number(tvShowId),
    seasonId: Number(seasonId),
    queryCategoryId: queryCategoryId,
    queryCollectionId: queryCollectionId,
    queryShowIndex: queryShowIndex,
    externalId: getEpisodePaymentExternalId({
      show: seriesPlaylist?.currentTvShow,
      season: seriesPlaylist?.currentSeason,
      episode,
    }),
    mediaType: getPaymentTvShowEpisodeMediaType(episode),
  }
}
